export const CHAT_STORAGE_KEY = "gotruck_ai_chat_messages"
export const TRIP_DATA_STORAGE_KEY = "gotruck_ai_trip_data"
export const MAX_API_MESSAGES = 20
export const MAX_MESSAGE_LENGTH = 1000

export const INITIAL_GREETING = `Hello! I'm **GoTruck Assistant**, your AI-powered logistics booking helper. Tell me what you'd like to move and I'll set everything up for you.`
